$ = jQuery;

function setup() {
  const $links = $(".js-linkedin-share");

  $links.click(function(event) {
    event.preventDefault();
    const href = $(this).attr("href");
    const width = 600;
    const height = 400;

    const winWidth = $(window).width();
    const winHeight = $(window).height();
    const specs = [
      `height=${height}`,
      `width=${width}`,
      `left=${(winWidth - width) / 2}`,
      `top=${(winHeight - height) / 2}`,
    ];
    window.open(href, "linkedin", specs.join(","));
  });
}

export default function() {
  $(setup);
}
